import { MapLayer, MapLayers } from 'features/mapping/mapping.constants';

export const initialMapLayersState: Record<MapLayer, boolean> = {
  [MapLayers.ACTIVE_FIRE_PERIMETERS]: true, // active by default
  [MapLayers.HISTORICAL_FIRE_PERIMETERS]: false,
  [MapLayers.MODIS]: false,
  [MapLayers.VIIRS]: false,
  [MapLayers.LANDSAT]: false,
  [MapLayers.NGFS_DETECTIONS]: false,
  [MapLayers.SMOKE_COVERAGE]: false,
  [MapLayers.PURPLE_AIR]: false,
  [MapLayers.LIGHTNING]: false,
  [MapLayers.SURFACE_WIND]: false,
  [MapLayers.FLIGHT_TRACKER]: false,
  [MapLayers.RADIO_TOWERS]: false,
  [MapLayers.RED_FLAG_WARNINGS]: true, // active by default
  [MapLayers.FLOOD_WEATHER]: true, // active by default
  [MapLayers.POWER_OUTAGES]: true,
  [MapLayers.CAMERAS]: false,
  [MapLayers.EVACUATION_ZONES]: false,
  [MapLayers.ELECTRICAL_LINES]: false,
  [MapLayers.GAS_PIPELINES]: false,
  [MapLayers.EXTERNAL_GEO_EVENTS]: false,
  [MapLayers.FEDERAL_STATE_LOCAL]: false,
  [MapLayers.RESPONSIBILITY_AREAS]: false,
  [MapLayers.ELECTRIC_RETAIL_SERVICE]: false,
  [MapLayers.PRIVATE_LAND_OWNERSHIP]: false,
  [MapLayers.WATER_LEVEL]: false,
  [MapLayers.WEATHER_STATIONS]: false,
  [MapLayers.FEMA_FLOOD_HAZARD]: false,
  // Marker entry so isLayerVisible treats team layers as user-controlled
  // (the per-team-layer toggle is keyed on the external layer id, not this).
  [MapLayers.TEAM_LAYER]: false,
  [MapLayers.TEAM_POLYGON_LAYER]: false,
};
